import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useParams, useNavigate } from "react-router-dom";
import {
  createProductPerformance,
  getProductPerformance,
  updateProductPerformance,
} from "../../../apis/ProductPerformanceApi";

export default function AddProductPerformance() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [addPerformance, setAddPerformance] = useState({
    category: "",
    crmProductId: "",
    crmShareClassGuid: "",
    date: "",
    nav: "",
    description: "",
    quarter: "",
  });

  const Navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    console.log(id, "iddddd in edit");
    if (id) {
      setEditLoading(true);
      editProducts(id);
    }
  }, [id]);
  const editProducts = async (id) => {
    setEditLoading(true);
    try {
      const res = await getProductPerformance(id);
      console.log(res.result.createdAt, "resr rersrersrersrrerrs");
      console.log(res);
      if (res) {
        setAddPerformance({
          category: res.result.category,
          crmProductId: res.result.crmProductId,
          crmShareClassGuid: res.result.crmShareClassGuid,
          nav: res.result.nav,
          //   date: res?.result?.createdAt,
          date: res.result.createdAt
            ? new Date(res.result.createdAt).toISOString().split("T")[0]
            : "",
          description: res.result.description,
          quarter: res.result.quarter,
        });
        setEditLoading(false);
      }
    } catch (error) {
      console.error("Error fetching faqs:", error);
    } finally {
      setLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: addPerformance,
    enableReinitialize: true,
    // validationSchema: AddProductsScheme,
    onSubmit: async (values) => {
      console.log(values, "checking values");
      try {
        setLoading(true);
        console.log(values, "values categories");
        let res;
        if (id) {
          res = await updateProductPerformance(id, values);
        } else {
          res = await createProductPerformance(values);
          console.log(res);
          //   setSuccess(true);
        }
        setLoading(false);
        Navigate("/product_performance");
        // setMessage(res.result.message);
        formik.resetForm();
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });
  const backClick = () => {
    Navigate("/product_performance");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{
                marginRight: "30px",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={backClick}
            />

            <div className="my-3 p-3 bg-body rounded shadow-sm">
              <h3>{id ? "Edit" : "Add"} Product Performance</h3>

              {editLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Category <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.category && formik.touched.category && (
                      <span className="text-danger">
                        {formik.errors.category}
                      </span>
                    )}
                  </div>

                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>

                    <textarea
                      className="form-control"
                      name="description"
                      placeholder="Enter description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      rows={4}
                    />

                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="text-danger">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Crm Product Id <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="crmProductId"
                      value={formik.values.crmProductId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.crmProductId &&
                      formik.touched.crmProductId && (
                        <span className="text-danger">
                          {formik.errors.crmProductId}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      CRM ShareClass GUID <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="crmShareClassGuid"
                      value={formik.values.crmShareClassGuid}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.crmShareClassGuid &&
                      formik.touched.crmShareClassGuid && (
                        <span className="text-danger">
                          {formik.errors.crmShareClassGuid}
                        </span>
                      )}
                  </div>

                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Quarter <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="quarter"
                      value={formik.values.quarter}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.quarter && formik.touched.quarter && (
                      <span className="text-danger">
                        {formik.errors.quarter}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Date<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      name="date"
                      value={formik.values.date}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.date && formik.touched.date && (
                      <span className="text-danger">{formik.errors.date}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      NAV <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="nav"
                      value={formik.values.nav}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.nav && formik.touched.nav && (
                      <span className="text-danger">{formik.errors.nav}</span>
                    )}
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
